import {
  SET_PAGINATION,
  SET_PAGE_INDEX,
  RESET_PAGE_AND_PAGINATION,
  SET_TYPE_OF_UPLOAD_DATASET,
  SET_ERROR_TYPE_OF_UPLOAD_DATASET,
  RESET_TYPE_OF_UPLOAD_DATASET
} from './types';

export const setPagination = pagination => ({ type: SET_PAGINATION, pagination });
export const setPageIndex = pageIndex => ({ type: SET_PAGE_INDEX, pageIndex });
export const resetPageAndPagination = () => ({ type: RESET_PAGE_AND_PAGINATION });

export const setTypeOfUploadDataset = typeOfUploadDataset => ({ type: SET_TYPE_OF_UPLOAD_DATASET, typeOfUploadDataset });
export const setErrorTypeOfUploadDataset = isErrorType => ({ type: SET_ERROR_TYPE_OF_UPLOAD_DATASET, isErrorType });

export const resetTypeOfUploadDataset = () => ({ type: RESET_TYPE_OF_UPLOAD_DATASET });
